import React from 'react'
import { ButtonLinkProps } from '@slite/components'
import { Link } from 'react-router-dom'
import { Button } from '../../components'
import { FormattedMessage, useIntl } from 'react-intl'

// Cannot use `ButtonLink` from the shared library ("Cannot use Link outside Router component")
// even though there's a single Router component wrapping this entire component
// The workaround below seems sufficient for this development-only component
const HomeLink = ({
  to,
  variant,
  children,
  className,
}: Pick<ButtonLinkProps, 'variant' | 'children' | 'to' | 'className'>) => {
  return (
    <Link to={to}>
      <Button variant={variant} className={className}>
        {children}
      </Button>
    </Link>
  )
}
export function Home() {
  const intl = useIntl()
  return (
    <div className=" flexbox flexbox-centered text-align-center">
      <div
        className="position-absolute flexbox flexbox-centered flexbox-column  text-align-center "
        style={{ top: '20%' }}
      >
        <img
          src="https://storage.googleapis.com/slite-cdn/misc/misland.jpg"
          alt={intl.formatMessage({
            id: 'boarding.createOrg.alt',
            defaultMessage: 'the adventure begins',
          })}
          style={{ width: '100px' }}
          className="margin-vertical-24"
        />

        <div className=" flexbox">
          <HomeLink
            variant="secondary"
            className="margin-horizontal-8"
            to="/organization/create"
          >
            <FormattedMessage
              id="boarding.createOrg.title"
              defaultMessage="Create my organization"
              values={{}}
            />
          </HomeLink>

          <HomeLink
            variant="secondary"
            className="margin-horizontal-8"
            to="/organization/join"
          >
            <FormattedMessage
              id="boarding.joinOrg.title"
              defaultMessage="Join an organization on Slite"
              values={{}}
            />
          </HomeLink>

          <HomeLink
            variant="secondary"
            className="margin-horizontal-8"
            to="/organization/select"
          >
            <FormattedMessage
              id="boarding.signIn.intoYourOrg"
              defaultMessage="Log into your organization's account"
              values={{}}
            />
          </HomeLink>

          <HomeLink
            variant="secondary"
            className="margin-horizontal-8"
            to="/organization/access"
          >
            <FormattedMessage
              id="boarding.accessDifferentOrg.title"
              defaultMessage="Access different organizations"
              values={{}}
            />
          </HomeLink>
        </div>
      </div>
    </div>
  )
}
